import { FC } from 'react';
import { useSessionStorage } from '../../../../../hooks';
import { getLocalStorageDistrictId } from '../../../../_core/utils';
import { FamilyAnswersPage } from './family-answers.page';

export const FamilyAnswersDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');

	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();
	return <FamilyAnswersPage isAdminRoute={false} currentDistrictId={districtId} />;
};
